import { mapState, mapActions, mapMutations } from 'vuex';

import GruposPermissoes from './util/gruposPermissoes.js';

export default {
  data() {
    return {
      infiniteLoadingId: 0,
      tabSelecionada: "permissoes",
      validacaoFormNome: {
        nome: [
          { required: true, message: "Nome é obrigatório" }
        ]
      },

      hoverGravar: false,
      hoverRemover: false
    }
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado; },
    }),
    ...mapState('perfisStore', {
      perfilPesquisa(state) { return state.perfilPesquisa },
      perfis(state) { return state.listaPerfis },
      labelQuantidade(state) { return state.labelQuantidade },
      perfil(state) { return state.perfilSelecionado }
    }),

    isVisiblePermissoesAluguel() {
      return this.usuarioLogado.imobiliaria && this.usuarioLogado.imobiliaria.moduloAluguel;
    },
    isVisiblePermissoesVenda() {
      return this.usuarioLogado.imobiliaria && this.usuarioLogado.imobiliaria.moduloVenda;
    },
    isVisiblePermissoesFinanceiro() {
      return this.usuarioLogado.imobiliaria && this.usuarioLogado.imobiliaria.moduloFinanceiro;
    },

    isVisibleWidgetAluguel() {
      return this.usuarioLogado.imobiliaria && this.usuarioLogado.imobiliaria.moduloAluguel;
    },
    isVisibleWidgetVenda() {
      return this.usuarioLogado.imobiliaria && this.usuarioLogado.imobiliaria.moduloVenda;
    },

    moduloPermissoesClientesAluguel() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CLIENTES_ALUGUEL'
        })[0];
    },
    moduloPermissoesImoveisAluguel() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'IMOVEIS_ALUGUEL'
        })[0];
    },
    moduloPermissoesContratosAluguel() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONTRATOS_ALUGUEL'
        })[0];
    },
    moduloPermissoesRelatoriosClientesAluguel() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_CLIENTES_ALUGUEL'
        })[0];
    },
    moduloPermissoesRelatoriosContratosAluguel() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_CONTRATOS_ALUGUEL'
        })[0];
    },
    moduloPermissoesRelatoriosImoveisAluguel() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_IMOVEIS_ALUGUEL'
        })[0];
    },
    moduloPermissoesRelatoriosPretendentesAluguel() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_PRETENDENTES_ALUGUEL'
        })[0];
    },
    moduloPermissoesRelatoriosFinanceirosAluguel() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_FINANCEIROS_ALUGUEL'
        })[0];
    },
    moduloPermissoesClientesVenda() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CLIENTES_VENDA'
        })[0];
    },
    moduloPermissoesImoveisVenda() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'IMOVEIS_VENDA';
        })[0];
    },
    moduloPermissoesContratosVenda() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONTRATOS_VENDA'
        })[0];
    },
    moduloPermissoesRelatoriosCaptacoesVenda() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_CAPTACOES_VENDA'
        })[0];
    },
    moduloPermissoesRelatoriosComissoesVenda() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_COMISSOES_VENDA'
        })[0];
    },
    moduloPermissoesRelatoriosClientesVenda() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_CLIENTES_VENDA'
        })[0];
    },
    moduloPermissoesRelatoriosImoveisVenda() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_IMOVEIS_VENDA'
        })[0];
    },
    moduloPermissoesRelatoriosPretendentesVenda() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_PRETENDENTES_VENDA'
        })[0];
    },
    moduloPermissoesContasReceber() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONTAS_RECEBER'
        })[0];
    },
    moduloPermissoesLancamentosContasReceber() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'LANCAMENTOS_CONTAS_RECEBER'
        })[0];
    },
    moduloPermissoesContasPagar() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONTAS_PAGAR'
        })[0];
    },
    moduloPermissoesLancamentosContasPagar() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'LANCAMENTOS_CONTAS_PAGAR'
        })[0];
    },
    moduloPermissoesCaixa() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CAIXA'
        })[0];
    },
    moduloPermissoesFornecedores() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'FORNECEDORES'
        })[0];
    },
    moduloPermissoesPlanosConta() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'PLANOS_CONTA'
        })[0];
    },
    moduloPermissoesGruposConta() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'GRUPOS_CONTA'
        })[0];
    },
    moduloPermissoesPretendentes() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'PRETENDENTES'
        })[0];
    },
    moduloPermissoesCondominios() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONDOMINIOS'
        })[0];
    },
    moduloPermissoesAdministradoras() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'ADMINISTRADORAS'
        })[0];
    },
    moduloPermissoesUsuarios() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'USUARIOS'
        })[0];
    },
    moduloPermissoesPerfisUsuarios() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'PERFIS_USUARIOS'
        })[0];
    },
    moduloPermissoesPlacas() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'PLACAS'
        })[0];
    },
    moduloPermissoesContasBancarias() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONTAS_BANCARIAS'
        })[0];
    },
    moduloPermissoesPortais() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'PORTAIS'
        })[0];
    },
    moduloPermissoesLogs() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'LOGS'
        })[0];
    },
    moduloPermissoesVisita() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'VISITA'
        })[0];
    },
    moduloPermissoesSistema() {
      return this.perfil.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'SISTEMA'
        })[0];
    },

    grupoAluguelClientes() { return GruposPermissoes.ALUGUEL_CLIENTES },
    grupoAluguelClientesCheckAll: {
      get() { return this.$store.state.perfisStore.grupoAluguelClientesCheckAll },
      set(value) { this.setGrupoAluguelClientesCheckAll(value) }
    },
    grupoAluguelClientesChecklist: {
      get() { return this.$store.state.perfisStore.grupoAluguelClientesChecklist },
      set(value) { this.setGrupoAluguelClientesChecklist(value) }
    },

    grupoAluguelBaixa() { return GruposPermissoes.ALUGUEL_BAIXA },
    grupoAluguelBaixaCheckAll: {
      get() { return this.$store.state.perfisStore.grupoAluguelBaixaCheckAll },
      set(value) { this.setGrupoAluguelBaixaCheckAll(value) }
    },
    grupoAluguelBaixaChecklist: {
      get() { return this.$store.state.perfisStore.grupoAluguelBaixaChecklist },
      set(value) { this.setGrupoAluguelBaixaChecklist(value) }
    },

    grupoAluguelLiberacaoRepasse() { return GruposPermissoes.ALUGUEL_LIBERACAO_REPASSE },
    grupoAluguelLiberacaoRepasseCheckAll: {
      get() { return this.$store.state.perfisStore.grupoAluguelLiberacaoRepasseCheckAll },
      set(value) { this.setGrupoAluguelLiberacaoRepasseCheckAll(value) }
    },
    grupoAluguelLiberacaoRepasseChecklist: {
      get() { return this.$store.state.perfisStore.grupoAluguelLiberacaoRepasseChecklist },
      set(value) { this.setGrupoAluguelLiberacaoRepasseChecklist(value) }
    },

    grupoAluguelImoveis() { return GruposPermissoes.ALUGUEL_IMOVEIS },
    grupoAluguelImoveisCheckAll: {
      get() { return this.$store.state.perfisStore.grupoAluguelImoveisCheckAll },
      set(value) { this.setGrupoAluguelImoveisCheckAll(value) }
    },
    grupoAluguelImoveisChecklist : {
      get() { return this.$store.state.perfisStore.grupoAluguelImoveisChecklist },
      set(value) { this.setGrupoAluguelImoveisChecklist(value) }
    },

    grupoAluguelContratos() { return GruposPermissoes.ALUGUEL_CONTRATOS },
    grupoAluguelContratosCheckAll: {
      get() { return this.$store.state.perfisStore.grupoAluguelContratosCheckAll },
      set(value) { this.setGrupoAluguelContratosCheckAll(value) }
    },
    grupoAluguelContratosChecklist: {
      get() { return this.$store.state.perfisStore.grupoAluguelContratosChecklist },
      set(value) { this.setGrupoAluguelContratosChecklist(value) }
    },

    grupoAluguelReajuste() { return GruposPermissoes.ALUGUEL_REAJUSTE },
    grupoAluguelReajusteCheckAll: {
      get() { return this.$store.state.perfisStore.grupoAluguelReajusteCheckAll },
      set(value) { this.setGrupoAluguelReajusteCheckAll(value) }
    },
    grupoAluguelReajusteChecklist: {
      get() { return this.$store.state.perfisStore.grupoAluguelReajusteChecklist },
      set(value) { this.setGrupoAluguelReajusteChecklist(value) }
    },

    grupoAluguelVencimento() { return GruposPermissoes.ALUGUEL_VENCIMENTO },
    grupoAluguelVencimentoCheckAll: {
      get() { return this.$store.state.perfisStore.grupoAluguelVencimentoCheckAll },
      set(value) { this.setGrupoAluguelVencimentoCheckAll(value) }
    },
    grupoAluguelVencimentoChecklist: {
      get() { return this.$store.state.perfisStore.grupoAluguelVencimentoChecklist },
      set(value) { this.setGrupoAluguelVencimentoChecklist(value) }
    },

    grupoRelatoriosClientesChecklist: {
      get() { return this.$store.state.perfisStore.grupoRelatoriosClientesChecklist },
      set(value) { this.setGrupoRelatoriosClientesChecklist(value) }
    },

    grupoRelatoriosContratos() { return GruposPermissoes.RELATORIOS_CONTRATOS },
    grupoRelatoriosContratosCheckAll: {
      get() { return this.$store.state.perfisStore.grupoRelatoriosContratosCheckAll },
      set(value) { this.setGrupoRelatoriosContratosCheckAll(value) }
    },
    grupoRelatoriosContratosChecklist: {
      get() { return this.$store.state.perfisStore.grupoRelatoriosContratosChecklist },
      set(value) { this.setGrupoRelatoriosContratosChecklist(value) }
    },

    grupoRelatoriosImoveis() { return GruposPermissoes.RELATORIOS_IMOVEIS },
    grupoRelatoriosImoveisCheckAll: {
      get() { return this.$store.state.perfisStore.grupoRelatoriosImoveisCheckAll },
      set(value) { this.setGrupoRelatoriosImoveisCheckAll(value) }
    },
    grupoRelatoriosImoveisChecklist: {
      get() { return this.$store.state.perfisStore.grupoRelatoriosImoveisChecklist },
      set(value) { this.setGrupoRelatoriosImoveisChecklist(value) }
    },

    grupoRelatoriosPretendentesChecklist: {
      get() { return this.$store.state.perfisStore.grupoRelatoriosPretendentesChecklist },
      set(value) { this.setGrupoRelatoriosPretendentesChecklist(value) }
    },

    grupoRelatoriosFinanceiros() { return GruposPermissoes.RELATORIOS_FINANCEIROS },
    grupoRelatoriosFinanceirosCheckAll: {
      get() { return this.$store.state.perfisStore.grupoRelatoriosFinanceirosCheckAll },
      set(value) { this.setGrupoRelatoriosFinanceirosCheckAll(value) }
    },
    grupoRelatoriosFinanceirosChecklist: {
      get() { return this.$store.state.perfisStore.grupoRelatoriosFinanceirosChecklist },
      set(value) { this.setGrupoRelatoriosFinanceirosChecklist(value) }
    },

    grupoVendaClientes() { return GruposPermissoes.VENDA_CLIENTES },
    grupoVendaClientesCheckAll: {
      get() { return this.$store.state.perfisStore.grupoVendaClientesCheckAll },
      set(value) { this.setGrupoVendaClientesCheckAll(value) }
    },
    grupoVendaClientesChecklist: {
      get() { return this.$store.state.perfisStore.grupoVendaClientesChecklist },
      set(value) { this.setGrupoVendaClientesChecklist(value) }
    },

    grupoVendaImoveis() { return GruposPermissoes.VENDA_IMOVEIS },
    grupoVendaImoveisCheckAll: {
      get() { return this.$store.state.perfisStore.grupoVendaImoveisCheckAll },
      set(value) { this.setGrupoVendaImoveisCheckAll(value) }
    },
    grupoVendaImoveisChecklist: {
      get() { return this.$store.state.perfisStore.grupoVendaImoveisChecklist },
      set(value) { this.setGrupoVendaImoveisChecklist(value) }
    },

    grupoVendaContratos() { return GruposPermissoes.VENDA_CONTRATOS },
    grupoVendaContratosCheckAll: {
      get() { return this.$store.state.perfisStore.grupoVendaContratosCheckAll },
      set(value) { this.setGrupoVendaContratosCheckAll(value) }
    },
    grupoVendaContratosChecklist: {
      get() { return this.$store.state.perfisStore.grupoVendaContratosChecklist },
      set(value) { this.setGrupoVendaContratosChecklist(value) }
    },

    grupoVendaRelatorios() { return GruposPermissoes.VENDA_RELATORIOS },
    grupoVendaRelatoriosCheckAll: {
      get() { return this.$store.state.perfisStore.grupoVendaRelatoriosCheckAll },
      set(value) { this.setGrupoVendaRelatoriosCheckAll(value) }
    },
    grupoVendaRelatoriosChecklist: {
      get() { return this.$store.state.perfisStore.grupoVendaRelatoriosChecklist },
      set(value) { this.setGrupoVendaRelatoriosChecklist(value) }
    },

    grupoFinanceiroContasReceber() { return GruposPermissoes.FINANCEIRO_CONTAS_RECEBER },
    grupoFinanceiroContasReceberCheckAll: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroContasReceberCheckAll },
      set(value) { this.setGrupoFinanceiroContasReceberCheckAll(value) }
    },
    grupoFinanceiroContasReceberChecklist: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroContasReceberChecklist },
      set(value) { this.setGrupoFinanceiroContasReceberChecklist(value) }
    },

    grupoFinanceiroLancamentosReceber() { return GruposPermissoes.FINANCEIRO_LANCAMENTOS_RECEBER },
    grupoFinanceiroLancamentosReceberCheckAll: {
      get() { return this.$store.state.grupoFinanceiroLancamentosReceberCheckAll },
      set(value) { this.setGrupoFinanceiroLancamentosReceberCheckAll(value) }
    },
    grupoFinanceiroLancamentosReceberChecklist: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroLancamentosReceberChecklist },
      set(value) { this.setGrupoFinanceiroLancamentosReceberChecklist(value) }
    },

    grupoFinanceiroContasPagar() { return GruposPermissoes.FINANCEIRO_CONTAS_PAGAR },
    grupoFinanceiroContasPagarCheckAll: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroContasPagarCheckAll },
      set(value) { this.setGrupoFinanceiroContasPagarCheckAll(value) }
    },
    grupoFinanceiroContasPagarChecklist: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroContasPagarChecklist },
      set(value) { this.setGrupoFinanceiroContasPagarChecklist(value) }
    },

    grupoFinanceiroLancamentosPagar() { return GruposPermissoes.FINANCEIRO_LANCAMENTOS_PAGAR },
    grupoFinanceiroLancamentosPagarCheckAll: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroLancamentosPagarCheckAll },
      set(value) { this.setGrupoFinanceiroLancamentosPagarCheckAll(value) }
    },
    grupoFinanceiroLancamentosPagarChecklist: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroLancamentosPagarChecklist },
      set(value) { this.setGrupoFinanceiroLancamentosPagarChecklist(value) }
    },

    grupoFinanceiroCaixa() { return GruposPermissoes.FINANCEIRO_CAIXA },
    grupoFinanceiroCaixaCheckAll: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroCaixaCheckAll },
      set(value) { this.setGrupoFinanceiroCaixaCheckAll(value) }
    },
    grupoFinanceiroCaixaChecklist: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroCaixaChecklist },
      set(value) { this.setGrupoFinanceiroCaixaChecklist(value) }
    },

    grupoFinanceiroFornecedores() { return GruposPermissoes.FINANCEIRO_FORNECEDORES },
    grupoFinanceiroFornecedoresCheckAll: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroFornecedoresCheckAll },
      set(value) { this.setGrupoFinanceiroFornecedoresCheckAll(value) }
    },
    grupoFinanceiroFornecedoresChecklist: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroFornecedoresChecklist },
      set(value) { this.setGrupoFinanceiroFornecedoresChecklist(value) }
    },

    grupoFinanceiroPlanosConta() { return GruposPermissoes.FINANCEIRO_PLANOS_CONTA },
    grupoFinanceiroPlanosContaCheckAll: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroPlanosContaCheckAll },
      set(value) { this.setGrupoFinanceiroPlanosContaCheckAll(value) }
    },
    grupoFinanceiroPlanosContaChecklist: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroPlanosContaChecklist },
      set(value) { this.setGrupoFinanceiroPlanosContaChecklist(value) }
    },

    grupoFinanceiroGruposConta() { return GruposPermissoes.FINANCEIRO_GRUPOS_CONTA },
    grupoFinanceiroGruposContaCheckAll: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroGruposContaCheckAll },
      set(value) { this.setGrupoFinanceiroGruposContaCheckAll(value) }
    },
    grupoFinanceiroGruposContaChecklist: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroGruposContaChecklist },
      set(value) { this.setGrupoFinanceiroGruposContaChecklist(value) }
    },

    grupoFinanceiroRelatorios() { return GruposPermissoes.FINANCEIRO_RELATORIOS },
    grupoFinanceiroRelatoriosCheckAll: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroRelatoriosCheckAll },
      set(value) { this.setGrupoFinanceiroRelatoriosCheckAll(value) },
    },
    grupoFinanceiroRelatoriosChecklist: {
      get() { return this.$store.state.perfisStore.grupoFinanceiroRelatoriosChecklist },
      set(value) { this.setGrupoFinanceiroRelatoriosChecklist(value) },
    },

    grupoConfiguracoesPretendentes() { return GruposPermissoes.CONFIGURACOES_PRETENDENTES },
    grupoConfiguracoesPretendentesCheckAll: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesPretendentesCheckAll },
      set(value) { this.setGrupoConfiguracoesPretendentesCheckAll(value) }
    },
    grupoConfiguracoesPretendentesChecklist: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesPretendentesChecklist },
      set(value) { this.setGrupoConfiguracoesPretendentesChecklist(value) }
    },

    grupoConfiguracoesCondominios() { return GruposPermissoes.CONFIGURACOES_CONDOMINIOS },
    grupoConfiguracoesCondominiosCheckAll: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesCondominiosCheckAll },
      set(value) { this.setGrupoConfiguracoesCondominiosCheckAll(value) }
    },
    grupoConfiguracoesCondominiosChecklist: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesCondominiosChecklist },
      set(value) { this.setGrupoConfiguracoesCondominiosChecklist(value) }
    },

    grupoConfiguracoesAdministradoras() { return GruposPermissoes.CONFIGURACOES_ADMINISTRADORAS },
    grupoConfiguracoesAdministradorasCheckAll: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesAdministradorasCheckAll },
      set(value) { this.setGrupoConfiguracoesAdministradorasCheckAll(value) }
    },
    grupoConfiguracoesAdministradorasChecklist: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesAdministradorasChecklist },
      set(value) { this.setGrupoConfiguracoesAdministradorasChecklist(value) }
    },

    grupoConfiguracoesUsuarios() { return GruposPermissoes.CONFIGURACOES_USUARIOS },
    grupoConfiguracoesUsuariosCheckAll: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesUsuariosCheckAll },
      set(value) { this.setGrupoConfiguracoesUsuariosCheckAll(value) }
    },
    grupoConfiguracoesUsuariosChecklist: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesUsuariosChecklist },
      set(value) { this.setGrupoConfiguracoesUsuariosChecklist(value) }
    },

    grupoConfiguracoesPerfis() { return GruposPermissoes.CONFIGURACOES_PERFIS },
    grupoConfiguracoesPerfisChecklist: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesPerfisChecklist },
      set(value) { this.setGrupoConfiguracoesPerfisChecklist(value) }
    },
    grupoConfiguracoesPerfisCheckAll: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesPerfisCheckAll },
      set(value) { this.setGrupoConfiguracoesPerfisCheckAll(value) }
    },

    grupoConfiguracoesPlacas() { return GruposPermissoes.CONFIGURACOES_PLACAS },
    grupoConfiguracoesPlacasCheckAll: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesPlacasCheckAll },
      set(value) { this.setGrupoConfiguracoesPlacasCheckAll(value) }
    },
    grupoConfiguracoesPlacasChecklist: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesPlacasChecklist },
      set(value) { this.setGrupoConfiguracoesPlacasChecklist(value) }
    },

    grupoConfiguracoesContas() { return GruposPermissoes.CONFIGURACOES_CONTAS },
    grupoConfiguracoesContasChecklist: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesContasChecklist },
      set(value) { this.setGrupoConfiguracoesContasChecklist(value) }
    },
    grupoConfiguracoesContasCheckAll: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesContasCheckAll },
      set(value) { this.setGrupoConfiguracoesContasCheckAll(value) }
    },

    grupoConfiguracoesPortais() { return GruposPermissoes.CONFIGURACOES_PORTAIS },
    grupoConfiguracoesPortaisCheckAll: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesPortaisCheckAll },
      set(value) { this.setGrupoConfiguracoesPortaisCheckAll(value) }
    },
    grupoConfiguracoesPortaisChecklist: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesPortaisChecklist },
      set(value) { this.setGrupoConfiguracoesPortaisChecklist(value) }
    },

    grupoConfiguracoesLogs() { return GruposPermissoes.CONFIGURACOES_LOGS },
    grupoConfiguracoesLogsCheckAll: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesLogsCheckAll },
      set(value) { this.setGrupoConfiguracoesLogsCheckAll(value) }
    },
    grupoConfiguracoesLogsChecklist: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesLogsChecklist },
      set(value) { this.setGrupoConfiguracoesLogsChecklist(value) }
    },

    grupoConfiguracoesVisitas() { return GruposPermissoes.CONFIGURACOES_VISITAS },
    grupoConfiguracoesVisitasCheckAll: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesVisitasCheckAll },
      set(value) { this.setGrupoConfiguracoesVisitasCheckAll(value) }
    },
    grupoConfiguracoesVisitasChecklist: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesVisitasChecklist },
      set(value) { this.setGrupoConfiguracoesVisitasChecklist(value) }
    },

    grupoConfiguracoesSistema() { return GruposPermissoes.CONFIGURACOES_SISTEMA },
    grupoConfiguracoesSistemaCheckAll: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesSistemaCheckAll },
      set(value) { this.setGrupoConfiguracoesSistemaCheckAll(value) }
    },
    grupoConfiguracoesSistemaChecklist: {
      get() { return this.$store.state.perfisStore.grupoConfiguracoesSistemaChecklist },
      set(value) { this.setGrupoConfiguracoesSistemaChecklist(value) }
    },

    novoPerfil() { return this.perfil.id === 0 },
    exibirBotaoRemoverPerfil() { return !this.novoPerfil }
  },
  methods: {
    ...mapMutations('perfisStore', [
      'setGrupoAluguelClientesCheckAll',
      'setGrupoAluguelClientesChecklist',

      'setGrupoAluguelBaixaCheckAll',
      'setGrupoAluguelBaixaChecklist',

      'setGrupoAluguelLiberacaoRepasseCheckAll',
      'setGrupoAluguelLiberacaoRepasseChecklist',

      'setGrupoAluguelImoveisCheckAll',
      'setGrupoAluguelImoveisChecklist',

      'setGrupoAluguelContratosCheckAll',
      'setGrupoAluguelContratosChecklist',

      'setGrupoAluguelReajusteCheckAll',
      'setGrupoAluguelReajusteChecklist',

      'setGrupoAluguelVencimentoCheckAll',
      'setGrupoAluguelVencimentoChecklist',

      'setGrupoRelatoriosClientesChecklist',

      'setGrupoRelatoriosContratosCheckAll',
      'setGrupoRelatoriosContratosChecklist',

      'setGrupoRelatoriosImoveisCheckAll',
      'setGrupoRelatoriosImoveisChecklist',

      'setGrupoRelatoriosPretendentesChecklist',

      'setGrupoRelatoriosFinanceirosCheckAll',
      'setGrupoRelatoriosFinanceirosChecklist',

      'setGrupoVendaClientesCheckAll',
      'setGrupoVendaClientesChecklist',

      'setGrupoVendaImoveisCheckAll',
      'setGrupoVendaImoveisChecklist',

      'setGrupoVendaContratosCheckAll',
      'setGrupoVendaContratosChecklist',

      'setGrupoVendaRelatoriosCheckAll',
      'setGrupoVendaRelatoriosChecklist',

      'setGrupoFinanceiroContasReceberCheckAll',
      'setGrupoFinanceiroContasReceberChecklist',

      'setGrupoFinanceiroLancamentosReceberCheckAll',
      'setGrupoFinanceiroLancamentosReceberChecklist',

      'setGrupoFinanceiroContasPagarCheckAll',
      'setGrupoFinanceiroContasPagarChecklist',

      'setGrupoFinanceiroLancamentosPagarCheckAll',
      'setGrupoFinanceiroLancamentosPagarChecklist',

      'setGrupoFinanceiroCaixaCheckAll',
      'setGrupoFinanceiroCaixaChecklist',

      'setGrupoFinanceiroFornecedoresCheckAll',
      'setGrupoFinanceiroFornecedoresChecklist',

      'setGrupoFinanceiroPlanosContaCheckAll',
      'setGrupoFinanceiroPlanosContaChecklist',

      'setGrupoFinanceiroGruposContaCheckAll',
      'setGrupoFinanceiroGruposContaChecklist',

      'setGrupoFinanceiroRelatoriosCheckAll',
      'setGrupoFinanceiroRelatoriosChecklist',

      'setGrupoConfiguracoesPretendentesCheckAll',
      'setGrupoConfiguracoesPretendentesChecklist',

      'setGrupoConfiguracoesCondominiosCheckAll',
      'setGrupoConfiguracoesCondominiosChecklist',

      'setGrupoConfiguracoesAdministradorasCheckAll',
      'setGrupoConfiguracoesAdministradorasChecklist',

      'setGrupoConfiguracoesUsuariosCheckAll',
      'setGrupoConfiguracoesUsuariosChecklist',

      'setGrupoConfiguracoesPerfisCheckAll',
      'setGrupoConfiguracoesPerfisChecklist',

      'setGrupoConfiguracoesPlacasCheckAll',
      'setGrupoConfiguracoesPlacasChecklist',

      'setGrupoConfiguracoesContasCheckAll',
      'setGrupoConfiguracoesContasChecklist',

      'setGrupoConfiguracoesPortaisCheckAll',
      'setGrupoConfiguracoesPortaisChecklist',

      'setGrupoConfiguracoesLogsCheckAll',
      'setGrupoConfiguracoesLogsChecklist',

      'setGrupoConfiguracoesVisitasCheckAll',
      'setGrupoConfiguracoesVisitasChecklist',

      'setGrupoConfiguracoesSistemaCheckAll',
      'setGrupoConfiguracoesSistemaChecklist'
    ]),
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('perfisStore', [
      'listarPerfis',
      'limparPerfisListados',
      'limparPerfilPesquisa',
      'recuperarPerfil',
      'limparPerfilSelecionado',
      'gravarPerfil',
      'removerPerfil'
    ]),
    pesquisar($state) {
      if(this.perfilPesquisa.pagina === 0) { this.showLoading() }
      this.listarPerfis(this.perfilPesquisa)
        .then((resultado) => {
          if(this.perfilPesquisa.pagina === 0) { this.hideLoading() }
          if(resultado.lista.length === 100) {
            this.perfilPesquisa.pagina += 1;
            $state.loaded();
          } else if(resultado.lista.length > 0 && this.perfilPesquisa.pagina === 0) {
            $state.loaded();
            $state.complete();
          } else {
            $state.complete();
          }
        }).catch(() => {
          if(this.perfilPesquisa.pagina === 0) { this.hideLoading() }
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    handleGrupoAluguelClientesCheckAllChange(checked) {
      this.setGrupoAluguelClientesChecklist(checked ? GruposPermissoes.ALUGUEL_CLIENTES_CHECK_ALL : []);
    },
    handleGrupoAluguelBaixaCheckAllChange(checked) {
      this.setGrupoAluguelBaixaChecklist(checked ? GruposPermissoes.ALUGUEL_BAIXA_CHECK_ALL : []);
    },
    handleGrupoAluguelLiberacaoRepasseCheckAllChange(checked) {
      this.setGrupoAluguelLiberacaoRepasseChecklist(checked ? GruposPermissoes.ALUGUEL_LIBERACAO_REPASSE_CHECK_ALL : []);
    },
    handleGrupoAluguelImoveisCheckAllChange(checked) {
      this.setGrupoAluguelImoveisChecklist(checked ? GruposPermissoes.ALUGUEL_IMOVEIS_CHECK_ALL : []);
    },
    handleGrupoAluguelContratosCheckAllChange(checked) {
      this.setGrupoAluguelContratosChecklist(checked ? GruposPermissoes.ALUGUEL_CONTRATOS_CHECK_ALL : []);
    },
    handleGrupoAluguelReajusteCheckAllChange(checked) {
      this.setGrupoAluguelReajusteChecklist(checked ? GruposPermissoes.ALUGUEL_REAJUSTE_CHECK_ALL : []);
    },
    handleGrupoAluguelVencimentoCheckAllChange(checked) {
      this.setGrupoAluguelVencimentoChecklist(checked ? GruposPermissoes.ALUGUEL_VENCIMENTO_CHECK_ALL : []);
    },
    handleGrupoRelatoriosContratosCheckAllChange(checked) {
      this.setGrupoRelatoriosContratosChecklist(checked ? GruposPermissoes.RELATORIOS_CONTRATOS_CHECK_ALL : []);
    },
    handleGrupoRelatoriosImoveisCheckAllChange(checked) {
      this.setGrupoRelatoriosImoveisChecklist(checked ? GruposPermissoes.RELATORIOS_IMOVEIS_CHECK_ALL : []);
    },
    handleGrupoRelatoriosFinanceirosCheckAllChange(checked) {
      this.setGrupoRelatoriosFinanceirosChecklist(checked ? GruposPermissoes.RELATORIOS_FINANCEIROS_CHECK_ALL : []);
    },
    handleGrupoVendaClientesCheckAllChange(checked) {
      this.setGrupoVendaClientesChecklist(checked ? GruposPermissoes.VENDA_CLIENTES_CHECK_ALL : []);
    },
    handleGrupoVendaImoveisCheckAllChange(checked) {
      this.setGrupoVendaImoveisChecklist(checked ? GruposPermissoes.VENDA_IMOVEIS_CHECK_ALL : []);
    },
    handleGrupoVendaContratosCheckAllChange(checked) {
      this.setGrupoVendaContratosChecklist(checked ? GruposPermissoes.VENDA_CONTRATOS_CHECK_ALL : []);
    },
    handleGrupoVendaRelatoriosCheckAllChange(checked) {
      this.setGrupoVendaRelatoriosChecklist(checked ? GruposPermissoes.VENDA_RELATORIOS_CHECK_ALL : []);
    },
    handleGrupoFinanceiroContasReceberCheckAllChange(checked) {
      this.setGrupoFinanceiroContasReceberChecklist(checked ? GruposPermissoes.FINANCEIRO_CONTAS_RECEBER_CHECK_ALL : []);
    },
    handleGrupoFinanceiroLancamentosReceberCheckAllChange(checked) {
      this.setGrupoFinanceiroLancamentosReceberChecklist(checked ? GruposPermissoes.FINANCEIRO_LANCAMENTOS_RECEBER_CHECK_ALL : []);
    },
    handleGrupoFinanceiroContasPagarCheckAllChange(checked) {
      this.setGrupoFinanceiroContasPagarChecklist(checked ? GruposPermissoes.FINANCEIRO_CONTAS_PAGAR_CHECK_ALL : []);
    },
    handleGrupoFinanceiroLancamentosPagarCheckAllChange(checked) {
      this.setGrupoFinanceiroLancamentosPagarChecklist(checked ? GruposPermissoes.FINANCEIRO_LANCAMENTOS_PAGAR_CHECK_ALL : []);
    },
    handleGrupoFinanceiroCaixaCheckAllChange(checked) {
      this.setGrupoFinanceiroCaixaChecklist(checked ? GruposPermissoes.FINANCEIRO_CAIXA_CHECK_ALL : []);
    },
    handleGrupoFinanceiroFornecedoresCheckAllChange(checked) {
      this.setGrupoFinanceiroFornecedoresChecklist(checked ? GruposPermissoes.FINANCEIRO_FORNECEDORES_CHECK_ALL : []);
    },
    handleGrupoFinanceiroPlanosContaCheckAllChange(checked) {
      this.setGrupoFinanceiroPlanosContaChecklist(checked ? GruposPermissoes.FINANCEIRO_PLANOS_CONTA_CHECK_ALL : []);
    },
    handleGrupoFinanceiroGruposContaCheckAllChange(checked) {
      this.setGrupoFinanceiroGruposContaChecklist(checked ? GruposPermissoes.FINANCEIRO_GRUPOS_CONTA_CHECK_ALL : []);
    },
    handleGrupoFinanceiroRelatoriosCheckAllChange(checked) {
      this.setGrupoFinanceiroRelatoriosChecklist(checked ? GruposPermissoes.FINANCEIRO_RELATORIOS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesPretendentesCheckAllChange(checked) {
      this.setGrupoConfiguracoesPretendentesChecklist(checked ? GruposPermissoes.CONFIGURACOES_PRETENDENTES_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesCondominiosCheckAllChange(checked) {
      this.setGrupoConfiguracoesCondominiosChecklist(checked ? GruposPermissoes.CONFIGURACOES_CONDOMINIOS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesAdministradorasCheckAllChange(checked) {
      this.setGrupoConfiguracoesAdministradorasChecklist(checked ? GruposPermissoes.CONFIGURACOES_ADMINISTRADORAS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesUsuariosCheckAllChange(checked) {
      this.setGrupoConfiguracoesUsuariosChecklist(checked ? GruposPermissoes.CONFIGURACOES_USUARIOS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesPerfisCheckAllChange(checked) {
      this.setGrupoConfiguracoesPerfisChecklist(checked ? GruposPermissoes.CONFIGURACOES_PERFIS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesPlacasCheckAllChange(checked) {
      this.setGrupoConfiguracoesPlacasChecklist(checked ? GruposPermissoes.CONFIGURACOES_PLACAS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesContasCheckAllChange(checked) {
      this.setGrupoConfiguracoesContasChecklist(checked ? GruposPermissoes.CONFIGURACOES_CONTAS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesPortaisCheckAllChange(checked) {
      this.setGrupoConfiguracoesPortaisChecklist(checked ? GruposPermissoes.CONFIGURACOES_PORTAIS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesLogsCheckAllChange(checked) {
      this.setGrupoConfiguracoesLogsChecklist(checked ? GruposPermissoes.CONFIGURACOES_LOGS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesVisitasCheckAllChange(checked) {
      this.setGrupoConfiguracoesVisitasChecklist(checked ? GruposPermissoes.CONFIGURACOES_VISITAS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesSistemaCheckAllChange(checked) {
      this.setGrupoConfiguracoesSistemaChecklist(checked ? GruposPermissoes.CONFIGURACOES_SISTEMA_CHECK_ALL : []);
    },

    dispararPesquisa() {
      this.perfilPesquisa.pagina = 0;
      this.limparPerfisListados();
      this.infiniteLoadingId += 1;
    },
    pesquisarHandler() {
      this.dispararPesquisa();
    },
    limparPesquisaHandler() {
      this.limparPerfilPesquisa();
    },
    recuperarHandler(perfil) {
      this.recuperar(perfil);
    },
    recuperar(perfil) {
      this.showLoading();
      this.recuperarPerfil(perfil)
        .then(() => {
          this.hideLoading();
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    novoPerfilHandler() {
      this.$refs["formNome"].resetFields();
      this.limparPerfilSelecionado();
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    gravarPerfilHandler() {
      this.$refs['formNome']
        .validate((valid) => {
          if(valid) {
            this.preencherPermissoes();
            this.gravar();
          } else {
            this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
          }
        });
    },

    preencherPermissoes() {
      this.preencherPermissoesGrupoAluguelClientes();
      this.preencherPermissoesGrupoAluguelBaixa();
      this.preencherPermissoesGrupoAluguelLiberacaoRepasse();
      this.preencherPermissoesGrupoAluguelImoveis();
      this.preencherPermissoesGrupoAluguelContratos();
      this.preencherPermissoesGrupoAluguelReajuste();
      this.preencherPermissoesGrupoAluguelVencimento();
      this.preencherPermissoesGrupoRelatoriosClientes();
      this.preencherPermissoesGrupoRelatoriosContratos();
      this.preencherPermissoesGrupoRelatoriosImoveis();
      this.preencherPermissoesGrupoRelatoriosPretendentes();
      this.preencherPermissoesGrupoRelatoriosFinanceiros();
      this.preencherPermissoesGrupoVendaClientes();
      this.preencherPermissoesGrupoVendaImoveis();
      this.preencherPermissoesGrupoVendaContratos();
      this.preencherPermissoesGrupoVendaRelatorios();
      this.preencherPermissoesGrupoFinanceiroContasReceber();
      this.preencherPermissoesGrupoFinanceiroLancamentosReceber();
      this.preencherPermissoesGrupoFinanceiroContasPagar();
      this.preencherPermissoesGrupoFinanceiroLancamentosPagar();
      this.preencherPermissoesGrupoFinanceiroCaixa();
      this.preencherPermissoesGrupoFinanceiroFornecedores();
      this.preencherPermissoesGrupoFinanceiroPlanosConta();
      this.preencherPermissoesGrupoFinanceiroGruposConta();
      this.preencherPermissoesGrupoFinanceiroRelatorios();
      this.preencherPermissoesGrupoConfiguracoesPretendentes();
      this.preencherPermissoesGrupoConfiguracoesCondominios();
      this.preencherPermissoesGrupoConfiguracoesAdministradoras();
      this.preencherPermissoesGrupoConfiguracoesUsuarios();
      this.preencherPermissoesGrupoConfiguracoesPerfis();
      this.preencherPermissoesGrupoConfiguracoesPlacas();
      this.preencherPermissoesGrupoConfiguracoesContas();
      this.preencherPermissoesGrupoConfiguracoesPortais();
      this.preencherPermissoesGrupoConfiguracoesLogs();
      this.preencherPermissoesGrupoConfiguracoesVisitas();
      this.preencherPermissoesGrupoConfiguracoesSistema();
    },

    preencherPermissoesGrupoAluguelClientes() {
      this.preencherGrupoPermissoes(this.moduloPermissoesClientesAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_CLIENTES, this.grupoAluguelClientesChecklist);
    },
    preencherPermissoesGrupoAluguelBaixa() {
      this.preencherGrupoPermissoes(this.moduloPermissoesClientesAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_BAIXA, this.grupoAluguelBaixaChecklist);
    },
    preencherPermissoesGrupoAluguelLiberacaoRepasse() {
      this.preencherGrupoPermissoes(this.moduloPermissoesClientesAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_LIBERACAO_REPASSE, this.grupoAluguelLiberacaoRepasseChecklist);
    },
    preencherPermissoesGrupoAluguelImoveis() {
      this.preencherGrupoPermissoes(this.moduloPermissoesImoveisAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_IMOVEIS, this.grupoAluguelImoveisChecklist);
    },
    preencherPermissoesGrupoAluguelContratos() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContratosAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_CONTRATOS, this.grupoAluguelContratosChecklist);
    },
    preencherPermissoesGrupoAluguelReajuste() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContratosAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_REAJUSTE, this.grupoAluguelReajusteChecklist);
    },
    preencherPermissoesGrupoAluguelVencimento() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContratosAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_VENCIMENTO, this.grupoAluguelVencimentoChecklist);
    },
    preencherPermissoesGrupoRelatoriosClientes() {
      this.moduloPermissoesRelatoriosClientesAluguel['visualizacao'] = this.grupoRelatoriosClientesChecklist.includes('visualizacao');
    },
    preencherPermissoesGrupoRelatoriosContratos() {
      this.preencherGrupoPermissoes(this.moduloPermissoesRelatoriosContratosAluguel, GruposPermissoes.PERMISSOES_RELATORIOS_CONTRATOS, this.grupoRelatoriosContratosChecklist);
    },
    preencherPermissoesGrupoRelatoriosImoveis() {
      this.preencherGrupoPermissoes(this.moduloPermissoesRelatoriosImoveisAluguel, GruposPermissoes.PERMISSOES_RELATORIOS_IMOVEIS, this.grupoRelatoriosImoveisChecklist);
    },
    preencherPermissoesGrupoRelatoriosPretendentes() {
      this.moduloPermissoesRelatoriosPretendentesAluguel['visualizacao'] = this.grupoRelatoriosPretendentesChecklist.includes('visualizacao');
    },
    preencherPermissoesGrupoRelatoriosFinanceiros() {
      this.preencherGrupoPermissoes(this.moduloPermissoesRelatoriosFinanceirosAluguel, GruposPermissoes.PERMISSOES_RELATORIOS_FINANCEIROS, this.grupoRelatoriosFinanceirosChecklist);
    },
    preencherPermissoesGrupoVendaClientes() {
      this.preencherGrupoPermissoes(this.moduloPermissoesClientesVenda, GruposPermissoes.PERMISSOES_VENDA_CLIENTES, this.grupoVendaClientesChecklist);
    },
    preencherPermissoesGrupoVendaImoveis() {
      this.preencherGrupoPermissoes(this.moduloPermissoesImoveisVenda, GruposPermissoes.PERMISSOES_VENDA_IMOVEIS, this.grupoVendaImoveisChecklist);
    },
    preencherPermissoesGrupoVendaContratos() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContratosVenda, GruposPermissoes.PERMISSOES_VENDA_CONTRATOS, this.grupoVendaContratosChecklist);
    },
    preencherPermissoesGrupoVendaRelatorios() {
      this.moduloPermissoesRelatoriosCaptacoesVenda['visualizacao'] = this.grupoVendaRelatoriosChecklist.includes('captacoesVisualizacao');
      this.moduloPermissoesRelatoriosComissoesVenda['visualizacao'] = this.grupoVendaRelatoriosChecklist.includes('comissoesVisualizacao');
      this.moduloPermissoesRelatoriosComissoesVenda['visualizacaoSomenteClientesCorretor'] = this.grupoVendaRelatoriosChecklist.includes('visualizacaoSomenteClientesCorretor');
      this.moduloPermissoesRelatoriosClientesVenda['visualizacao'] = this.grupoVendaRelatoriosChecklist.includes('clientesVisualizacao');
      this.moduloPermissoesRelatoriosImoveisVenda['visualizacao'] = this.grupoVendaRelatoriosChecklist.includes('imoveisVisualizacao');
      this.moduloPermissoesRelatoriosPretendentesVenda['visualizacao'] = this.grupoVendaRelatoriosChecklist.includes('pretendentesVisualizacao');
    },
    preencherPermissoesGrupoFinanceiroContasReceber() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContasReceber, GruposPermissoes.PERMISSOES_FINANCEIRO_CONTAS_RECEBER, this.grupoFinanceiroContasReceberChecklist);
    },
    preencherPermissoesGrupoFinanceiroLancamentosReceber() {
      this.preencherGrupoPermissoes(this.moduloPermissoesLancamentosContasReceber, GruposPermissoes.PERMISSOES_FINANCEIRO_LANCAMENTOS_RECEBER, this.grupoFinanceiroLancamentosReceberChecklist);
    },
    preencherPermissoesGrupoFinanceiroContasPagar() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContasPagar, GruposPermissoes.PERMISSOES_FINANCEIRO_CONTAS_PAGAR, this.grupoFinanceiroContasPagarChecklist);
    },
    preencherPermissoesGrupoFinanceiroLancamentosPagar() {
      this.preencherGrupoPermissoes(this.moduloPermissoesLancamentosContasPagar, GruposPermissoes.PERMISSOES_FINANCEIRO_LANCAMENTOS_PAGAR, this.grupoFinanceiroLancamentosPagarChecklist);
    },
    preencherPermissoesGrupoFinanceiroCaixa() {
      this.preencherGrupoPermissoes(this.moduloPermissoesCaixa, GruposPermissoes.PERMISSOES_FINANCEIRO_CAIXA, this.grupoFinanceiroCaixaChecklist);
    },
    preencherPermissoesGrupoFinanceiroFornecedores() {
      this.preencherGrupoPermissoes(this.moduloPermissoesFornecedores, GruposPermissoes.PERMISSOES_FINANCEIRO_FORNECEDORES, this.grupoFinanceiroFornecedoresChecklist);
    },
    preencherPermissoesGrupoFinanceiroPlanosConta() {
      this.preencherGrupoPermissoes(this.moduloPermissoesPlanosConta, GruposPermissoes.PERMISSOES_FINANCEIRO_PLANOS_CONTA, this.grupoFinanceiroPlanosContaChecklist);
    },
    preencherPermissoesGrupoFinanceiroGruposConta() {
      this.preencherGrupoPermissoes(this.moduloPermissoesGruposConta, GruposPermissoes.PERMISSOES_FINANCEIRO_GRUPOS_CONTA, this.grupoFinanceiroGruposContaChecklist);
    },
    preencherPermissoesGrupoFinanceiroRelatorios() {
      this.moduloPermissoesContasPagar['relatorioContasPagas'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasPagas');
      this.moduloPermissoesContasPagar['relatorioContasAPagar'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasAPagar');
      this.moduloPermissoesContasPagar['relatorioContasAPagarVencidas'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasAPagarVencidas');
      this.moduloPermissoesContasReceber['relatorioContasRecebidas'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasRecebidas');
      this.moduloPermissoesContasReceber['relatorioContasAReceber'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasAReceber');
      this.moduloPermissoesContasReceber['relatorioContasAReceberVencidas'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasAReceberVencidas');
      this.moduloPermissoesContasReceber['relatorioCheques'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioCheques');
    },
    preencherPermissoesGrupoConfiguracoesPretendentes() {
      this.preencherGrupoPermissoes(this.moduloPermissoesPretendentes, GruposPermissoes.PERMISSOES_CONFIGURACOES_PRETENDENTES, this.grupoConfiguracoesPretendentesChecklist);
    },
    preencherPermissoesGrupoConfiguracoesCondominios() {
      this.preencherGrupoPermissoes(this.moduloPermissoesCondominios, GruposPermissoes.PERMISSOES_CONFIGURACOES_CONDOMINIOS, this.grupoConfiguracoesCondominiosChecklist);
    },
    preencherPermissoesGrupoConfiguracoesAdministradoras() {
      this.preencherGrupoPermissoes(this.moduloPermissoesAdministradoras, GruposPermissoes.PERMISSOES_CONFIGURACOES_ADMINISTRADORAS, this.grupoConfiguracoesAdministradorasChecklist);
    },
    preencherPermissoesGrupoConfiguracoesUsuarios() {
      this.preencherGrupoPermissoes(this.moduloPermissoesUsuarios, GruposPermissoes.PERMISSOES_CONFIGURACOES_USUARIOS, this.grupoConfiguracoesUsuariosChecklist);
    },
    preencherPermissoesGrupoConfiguracoesPerfis() {
      this.preencherGrupoPermissoes(this.moduloPermissoesPerfisUsuarios, GruposPermissoes.PERMISSOES_CONFIGURACOES_PERFIS, this.grupoConfiguracoesPerfisChecklist);
    },
    preencherPermissoesGrupoConfiguracoesPlacas() {
      this.preencherGrupoPermissoes(this.moduloPermissoesPlacas, GruposPermissoes.PERMISSOES_CONFIGURACOES_PLACAS, this.grupoConfiguracoesPlacasChecklist);
    },
    preencherPermissoesGrupoConfiguracoesContas() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContasBancarias, GruposPermissoes.PERMISSOES_CONFIGURACOES_CONTAS, this.grupoConfiguracoesContasChecklist);
    },
    preencherPermissoesGrupoConfiguracoesPortais() {
      this.preencherGrupoPermissoes(this.moduloPermissoesPortais, GruposPermissoes.PERMISSOES_CONFIGURACOES_PORTAIS, this.grupoConfiguracoesPortaisChecklist);
    },
    preencherPermissoesGrupoConfiguracoesLogs() {
      this.preencherGrupoPermissoes(this.moduloPermissoesLogs, GruposPermissoes.PERMISSOES_CONFIGURACOES_LOGS, this.grupoConfiguracoesLogsChecklist);
    },
    preencherPermissoesGrupoConfiguracoesVisitas() {
      this.preencherGrupoPermissoes(this.moduloPermissoesVisita, GruposPermissoes.PERMISSOES_CONFIGURACOES_VISITAS, this.grupoConfiguracoesVisitasChecklist);
    },
    preencherPermissoesGrupoConfiguracoesSistema() {
      this.preencherGrupoPermissoes(this.moduloPermissoesSistema, GruposPermissoes.PERMISSOES_CONFIGURACOES_SISTEMA, this.grupoConfiguracoesSistemaChecklist);
    },

    preencherGrupoPermissoes(modulo, permissoesGrupo, checkList) {
      for(let permissao of permissoesGrupo) {
        modulo[permissao] = checkList.includes(permissao);
      }
    },
    
    gravar() {
      this.showLoading();
      this.gravarPerfil(this.perfil)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.dispararPesquisa();
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    removerPerfilHandler() {
      this.$confirm("Deseja realmente remover este Perfil?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.remover();
      }).catch(() => {});
    },
    remover() {
      this.showLoading();
      this.removerPerfil(this.perfil)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.dispararPesquisa();
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    }
  }
};